import MatchedMap from 'utilities/src/matchedMap';

import { InputThemeEnum, type InputThemeProps } from '../../../utils/themes';

/**
 * MessageError Common Classes
 */

const messageErrorWrapperClasses = 'flex items-center gap-1';

const messageErrorTextClasses = 'site-paragraph-xs';

/**
 * MessageError Theme Classes
 */

const messageErrorTextColorClassesMap = new MatchedMap([
  [InputThemeEnum.Dark, 'text-site-error-600'],
  [InputThemeEnum.Light, 'text-site-error-700'],
]);

const messageErrorIconColorClassesMap = new MatchedMap([
  [InputThemeEnum.Dark, 'fill-site-error-600'],
  [InputThemeEnum.Light, 'fill-site-error-700'],
]);

/**
 * Site Theme
 */

const inputMessageErrorSiteTheme = ({ inputTheme }: Pick<InputThemeProps, 'inputTheme'>) => ({
  messageErrorWrapperThemeClasses: messageErrorWrapperClasses,
  messageErrorTextThemeClasses: messageErrorTextClasses,
  messageErrorTextColorThemeClasses: messageErrorTextColorClassesMap.get(InputThemeEnum[inputTheme]),
  messageErrorIconColorThemeClasses: messageErrorIconColorClassesMap.get(InputThemeEnum[inputTheme]),
});

export default inputMessageErrorSiteTheme;
